export default __webpack_public_path__ + "static/media/Delete.d7b32e55.svg";